import React from "react";
import "./TestimonyCards.css";

interface TestimonyCardProps {
  username: string;
  subtitle: string;
  desc: string;
  onReadFull?: () => void;
  maxWords?: number;
}

function truncateWords(text: string, maxWords: number) {
  const words = text.split(" ");
  if (words.length <= maxWords) return text;
  return words.slice(0, maxWords).join(" ") + "...";
}

const TestimonyCard: React.FC<TestimonyCardProps> = ({
  username,
  subtitle,
  desc,
  onReadFull,
  maxWords = 25,
}) => (
  <div className="testimony-card horizontal-scroll-card">
    <div className="testimony-username">{username}</div>
    <div className="testimony-subtitle">{subtitle}</div>
    <div className="testimony-desc">{truncateWords(desc, maxWords)}</div>
    <button className="testimony-btn" onClick={onReadFull}>
      Read Full
    </button>
  </div>
);

export default TestimonyCard;
